<template>
  <div class="upload">
    <el-upload ref="uploadRef" v-model:file-list="fileList" class="avatar-uploaders" action="" list-type="picture-card"
      :show-file-list="false" :on-change="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
      :on-remove="handleRemove" :on-preview="handlePictureCardPreview" :auto-upload="false" :http-request="uploadImage"
      :on-exceed="handleExceed" :limit="1">
      <img v-if="imageUrl" :src="imageServerUrl+imageUrl" class="avatar" />
      <el-icon v-else class="avatar-uploader-icon">
        <Plus />
      </el-icon>
    </el-upload>
  </div>
  <el-dialog v-model="dialogVisible">
    <img w-full :src="dialogImageUrl" alt="Preview Image" />
  </el-dialog>
</template>

<script setup>
import { ref } from 'vue'
import { ElMessage, genFileId } from 'element-plus'
import { Plus } from '@element-plus/icons-vue'
import { commonUpload } from '@/api/common'

const emits = defineEmits(['uploadImage', 'imgUrl'])
const props = defineProps(['imageUrl'])

const uploadRef = ref(null)
const fileList = ref([])
const imageUrl = ref('');
const imageUrlSrc=ref('');
const dialogVisible = ref(false);
 

const imageServerUrl = import.meta.env.VITE_BASE_File_SERVER_URL;


watch(() => props.imageUrl, (newVal) => {
  imageUrl.value = newVal || ''
}, {
  immediate: true,
  deep: true
})

function handleAvatarSuccess(response) {
  uploadImage(response.raw)
}

function beforeAvatarUpload(rawFile) {
  console.log('rawFile', rawFile);
  if (rawFile.type !== 'image/jpeg') {
    ElMessage.error('Avatar picture must be JPG format!')
    return false
  } else if (rawFile.size / 1024 / 1024 > 10) {
    ElMessage.error('Avatar picture size can not exceed 10MB!')
    return false
  }
  return true
}

function handleExceed(files) {
  uploadRef.value.clearFiles()
  imageUrl.value = '';
  const file = files[0]
  file.uid = genFileId()
  if (uploadRef) {
    uploadRef.handleStart(file);
  }
  // uploadRef.value!.handleStart(file)
}

function handlePictureCardPreview(uploadFile) {
  dialogImageUrl.value = uploadFile.url
  dialogVisible.value = true
}

function handleRemove(uploadFile, uploadFiles) {
  console.log('1', uploadFile, uploadFiles)
}

async function uploadImage(file) {
  try {
    const formData = new FormData()
    formData.append('files', file)
    let res = await commonUpload(formData)
    imageUrl.value = res[0].url
    emits('uploadImage', imageUrl.value)
  } catch (error) {
    console.log(error)
  }
}

function clearImageUrl() {
  imageUrl.value = '';
}

defineExpose({
  clearImageUrl
})
</script>

<style scoped lang="scss">
.upload {
  .avatar-uploaders {
    .avatar {
      width: 148px;
      height: 148px;
      display: block;
    }

    .el-upload {
      border: 1px dashed #cdd0d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .el-upload:hover {
      border-color: #409eff;
    }
  }

  .el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    text-align: center;
  }
}
</style>
